import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { service } from './reducers/service';

const rootReducer = combineReducers({
  form: formReducer,
  service,
});

export default rootReducer;
